import { AIInsight } from "../types";

export function parseAIResult(raw: string | null | undefined): AIInsight | null {
    if (!raw || typeof raw !== "string") return null;

    try {
        // Attempt to extract fenced JSON
        const match = raw.match(/```(?:json)?\s*([\s\S]*?)\s*```/i);
        let jsonString = match ? match[1] : raw.trim();

        // console.log("Raw AI result:", raw);
        // console.log("JSON candidate:", jsonString);

        // Validate if it looks like a JSON object
        const looksLikeObject = jsonString.startsWith("{") && jsonString.endsWith("}");
        if (!looksLikeObject) {
            console.warn("Input does not look like a valid JSON object. Skipping parse.");
            return null;
        }

        const parsed = JSON.parse(jsonString);

        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
            return parsed as AIInsight;
        } else {
            console.warn("Parsed value is not a plain object:", parsed);
            return null;
        }
    } catch (err) {
        console.error("Failed to parse AI result:", err);
        return null;
    }
}
